/**
 * Recos Potions du tiroir de panier — ré-exécution du script inline.
 *
 * Le bloc recos du tiroir (#section-potions) est alimenté par un
 * <script type="module"> inline (#potions-script) rendu par le snippet
 * `potions-js`. Dès que le HTML du tiroir est remplacé, ce script réatterrit
 * dans le DOM sous forme de noeud inerte : un <script> injecté via innerHTML
 * ou DOMParser n'est jamais exécuté par le navigateur. Le slider reste alors
 * bloqué sur son <li> placeholder, donc vide.
 *
 * Le thème appelait déjà reloadPotionsScript() après ses propres rendus
 * (cart.js / cart-drawer.js), mais pas les apps tierces : Kite (cadeau
 * offert) recharge la section `cart-drawer` de son côté et remplace
 * `.drawer__inner` par replaceWith(), sans repasser par le thème — d'où la
 * disparition des recos dès qu'un produit gratuit est ajouté.
 *
 * On surveille donc le tiroir et on rejoue tout nouveau #potions-script,
 * quelle que soit l'origine du re-rendu.
 */
(function () {
  const EXECUTED_ATTR = 'data-potions-executed';
  const REINJECTED_ATTR = 'data-potions-reinjected';
  const DEBOUNCE_MS = 50;

  // Bascule data-reco-noid -> data-reco-id (tracking AB Tasty), comme le fait
  // CartDrawer.open() : uniquement quand le tiroir est effectivement ouvert.
  function activatePotionsRecoId() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;

    const potionsSection = drawer.querySelector('[data-reco-noid]');
    if (!potionsSection) return;

    potionsSection.setAttribute('data-reco-id', potionsSection.getAttribute('data-reco-noid'));
    potionsSection.removeAttribute('data-reco-noid');
  }

  // Rejoue le script Potions présent dans le tiroir s'il n'a pas déjà été exécuté.
  function reloadPotionsScript() {
    const potionsScript = document.querySelector('#potions-script');
    if (!potionsScript || potionsScript.hasAttribute(EXECUTED_ATTR)) return;

    // Marqué avant l'injection : évite qu'un second appel (thème + observer,
    // ou deux mutations rapprochées) ne relance deux fois le même script.
    potionsScript.setAttribute(EXECUTED_ATTR, 'true');

    document.querySelectorAll('script[' + REINJECTED_ATTR + ']').forEach((script) => script.remove());

    const newScript = document.createElement('script');
    newScript.type = potionsScript.type || 'module';
    newScript.setAttribute(REINJECTED_ATTR, 'true');
    newScript.textContent = potionsScript.textContent;
    document.body.appendChild(newScript);

    activatePotionsRecoId();
  }

  window.reloadPotionsScript = reloadPotionsScript;

  function init() {
    // Au premier chargement, le script inline est exécuté nativement par le
    // navigateur : on le marque pour ne pas le rejouer inutilement.
    document
      .querySelectorAll('#potions-script')
      .forEach((script) => script.setAttribute(EXECUTED_ATTR, 'true'));

    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        reloadPotionsScript();
      }, DEBOUNCE_MS);
    });

    // subtree: le tiroir est remplacé soit par innerHTML sur #CartDrawer
    // (thème), soit par replaceWith sur .drawer__inner (Kite).
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
